@if (contractors().length) {
  <app-accordion-group>
    @for (contractor of contractors(); track $index) {
      <app-accordion-item [expanded]="expanded" [name]='$index + 1 + ". " + (contractor | entityLabel)'>
        <div class='row'>
          @if (contractor?.nip; as nip) {
            <div class="col-md-4">
              <app-label label="NIP:">
                {{ nip }}
              </app-label>
            </div>
          }
          <div class='col-md-4'>
            <app-label label='Numer telefonu:'>
              {{ contractor?.phoneNumber || '-' }}
            </app-label>
          </div>
          <div class='col-md-4'>
            <app-label label='Numer telefonu2:'>
              {{ contractor?.phoneNumber2 || '-' }}
            </app-label>
          </div>
          <div class='col-md-4'>
            <app-label label='E-mail:'>
              {{ contractor?.email || '-' }}
            </app-label>
          </div>
          <div class='col-md-4'>
            <app-label label='Kod pocztowy:'>
              {{ contractor?.postalCode || '-' }}
            </app-label>
          </div>
          <div class='col-md-4'>
            <app-label label='Poczta:'>
              {{ contractor?.postOffice || '-' }}
            </app-label>
          </div>
          <div class='col-md-4'>
            <app-label label='Miejscowość:'>
              {{ contractor?.city || '-' }}
            </app-label>
          </div>
          <div class='col-md-4'>
            <app-label label='Ulica:'>
              {{ contractor?.street || '-' }}
            </app-label>
          </div>
          <div class='col-md-4'>
            <app-label label='Nr domu:'>
              {{ contractor?.houseNumber || '-' }}
            </app-label>
          </div>
          <div class='col-md-4'>
            <app-label label='Nr mieszkania:'>
              {{ contractor?.apartmentNumber || '-' }}
            </app-label>
          </div>
        </div>
        <span slot='action'>
        @if (showActions()) {
          <button
            (click)='edit($event, $index, contractor)'
            class='btn btn-secondary icon-btn'
            title='Edytuj'
            [disabled]='!canEdit()'>
          <i class='fa fa-pencil-alt'></i>
          </button>
          &nbsp;
          <button
            [disabled]='!canEdit()'
            type='button'
            class='btn btn-red-secondary icon-btn'
            title='Usuń z listy'
            (click)='remove($event, $index)'>
            <i class='fa fa-trash-alt'></i>
          </button>
        }
      </span>
      </app-accordion-item>
    }
  </app-accordion-group>
} @else {
  <br>
  <app-alert [closable]="false" type="info" [alertTittle]="noDataInfo || 'Brak dodanych wykonawców!'"></app-alert>
}
